import React from "react";

export default function SettingsSectionIntro({ title, description }) {
  return (
    <div>
      <h2 className="font-SFPro font-semibold text-xl text-gray-900">{title}</h2>
      <p className="text-sm text-gray-500 mt-1">{description}</p>
    </div>
  );
}
